<template>
    <div>
        <div class="text-24 text-tc-blue-2 text-center">
            {{lbl.register.title_terms}}
        </div>
        <div class="pt-3 pb-5 content-term-con text-20 text-tc-gray-3" v-html="content1"></div>
        <div class="text-24 text-tc-blue-2 text-center">
            {{lbl.register.title_terms2}}
        </div>
        <div class="pt-3 pb-24 content-term-con text-20 text-tc-gray-3" v-html="content2"></div>
    </div>
</template>

<script>
// core
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA.js';
import UserConsentPDPAModel from '@/core/PDPA/model/UserConsentModel.js';
//helper
// import Account from "@/helper/AccountHelper.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component


export default {
    name: 'Content',
    mixins: [LocaleMixin],
    props:{
        modalController: Object
    },
    components:{

    },
    data: function(){
        return{
            title1: '',
            content1: '',

            title2: '',
            content2: '',

            termsVersion: null,
        }
    },

    methods:{
        apiGetUserConsent: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetUserConsent()
                    .subscribe({
                        next: (res) => {
                            let data = new UserConsentPDPAModel(res.data)
                            if(this.localeCode === 1033){ //en
                                this.content1 = data.content_header_en
                                this.content2 = data.content_purposes_en
                            }else{ //th
                                this.content1 = data.content_header_th
                                this.content2 = data.content_purposes_th
                            }
                            resolve(res);
                        },
                        error: (err) => {
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },

        getBzbsTerms: async function() {
            this.modalController.loadingModal.show();
            await this.getVersion();
            await this.getContent();
            this.modalController.loadingModal.hide();
        },
        getVersion: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAVersion()
                    .subscribe({
                        next: (res) => {
                            console.log('pdpa', res);
                            const result = res.terms.current_version;

                            this.termsVersion = result;
                            resolve(true);
                        },
                        error: (err) => {
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
        getContent: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAContent('terms', this.termsVersion, this.localeCode)
                    .subscribe({
                        next: (res) => {
                            this.content = res;

                            resolve(res);
                        },
                        error: (err) => {
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
    }
};
</script>

<style lang="scss">
.content-term-con{
    text-indent: 2em;
    a {
        color: #144394;
    }
}
</style>
